/** Five reviews across Google and Facebook, three of them answered. */

import { DEMO_WEBSITE_ID } from './site';
import { daysAgo } from './time';

export interface DemoReview {
  id: string;
  websiteId: string;
  platform: string;
  rating: number;
  reviewerName: string;
  reviewText: string;
  reviewUrl: string | null;
  responded: boolean;
  response: string | null;
  respondedAt: string | null;
  reviewDate: string;
  createdAt: string;
}

export interface DemoReviewRequest {
  id: string;
  websiteId: string;
  customerName: string;
  customerEmail: string | null;
  customerPhone: string | null;
  status: string;
  sentAt: string | null;
  completedAt: string | null;
  createdAt: string;
}

export const demoReviews: DemoReview[] = [
  {
    id: 'demo-review-1',
    websiteId: DEMO_WEBSITE_ID,
    platform: 'google',
    rating: 5,
    reviewerName: 'Elaine Brooks',
    reviewText:
      'Sump pump gave out in the middle of a storm and Republic had someone at the house within two hours. Explained what failed, showed me the old check valve, cleaned up after. Straight price, no upsell.',
    reviewUrl: null,
    responded: true,
    response: 'Thanks Elaine — glad we caught it before the water got any higher. Give us a shout if the new pump ever sounds off.',
    respondedAt: daysAgo(6),
    reviewDate: daysAgo(7),
    createdAt: daysAgo(7),
  },
  {
    id: 'demo-review-2',
    websiteId: DEMO_WEBSITE_ID,
    platform: 'google',
    rating: 5,
    reviewerName: 'Hector Alvarez',
    reviewText:
      'Split spigot from the freeze. Sarah quoted over the phone, came out the next morning and the price matched the quote exactly.',
    reviewUrl: null,
    responded: true,
    response: 'Appreciate the review, Hector — and thanks for sending your neighbour our way.',
    respondedAt: daysAgo(9),
    reviewDate: daysAgo(10),
    createdAt: daysAgo(10),
  },
  {
    id: 'demo-review-3',
    websiteId: DEMO_WEBSITE_ID,
    platform: 'facebook',
    rating: 4,
    reviewerName: 'Nadia Petrov',
    reviewText:
      'Good work on the laundry hookups. Only reason for four stars is that the first appointment got moved, but they called ahead and were honest about why.',
    reviewUrl: null,
    responded: false,
    response: null,
    respondedAt: null,
    reviewDate: daysAgo(18),
    createdAt: daysAgo(18),
  },
  {
    id: 'demo-review-4',
    websiteId: DEMO_WEBSITE_ID,
    platform: 'google',
    rating: 5,
    reviewerName: 'Jerome Fields',
    reviewText: 'Replaced a leaking shut-off under the kitchen sink in about twenty minutes. Tidy, polite, fair.',
    reviewUrl: null,
    responded: true,
    response: 'Thank you, Jerome. Those little valves fail quietly — good that you spotted it.',
    respondedAt: daysAgo(25),
    reviewDate: daysAgo(26),
    createdAt: daysAgo(26),
  },
  {
    id: 'demo-review-5',
    websiteId: DEMO_WEBSITE_ID,
    platform: 'google',
    rating: 5,
    reviewerName: 'Bethany Cole',
    reviewText:
      'We had three bids for a water heater. Republic was the only one that actually looked at the vent before quoting.',
    reviewUrl: null,
    responded: false,
    response: null,
    respondedAt: null,
    reviewDate: daysAgo(34),
    createdAt: daysAgo(34),
  },
];

export const demoReviewRequests: DemoReviewRequest[] = [
  {
    id: 'demo-request-1',
    websiteId: DEMO_WEBSITE_ID,
    customerName: 'Marcus Webb',
    customerEmail: 'marcus.webb@example.com',
    customerPhone: '(608) 555-0143',
    status: 'sent',
    sentAt: daysAgo(1),
    completedAt: null,
    createdAt: daysAgo(1),
  },
  {
    id: 'demo-request-2',
    websiteId: DEMO_WEBSITE_ID,
    customerName: 'Hector Alvarez',
    customerEmail: 'halvarez@example.com',
    customerPhone: null,
    status: 'completed',
    sentAt: daysAgo(11),
    completedAt: daysAgo(10),
    createdAt: daysAgo(11),
  },
];
